// LOGIN
export const LOGIN = 'LOGIN'
export const LOCAL_CREDENTIALS = 'LOCAL_CREDENTIALS'
export const GET_LOCAL_CREDENTIALS = 'GET_LOCAL_CREDENTIALS'
export const SET_USER_DETAILS = 'SET_USER_DETAILS'
export const RESET = 'RESET'
export const GET_LOGIN_CONFIGS = 'GET_LOGIN_CONFIGS'

// USER MANAGEMENTS
export const GET_USER_LIST = 'GET_USER_LIST'
export const GET_GROUP_LIST = 'GET_GROUP_LIST'
export const GET_PERMISSIONS = 'GET_PERMISSIONS'
export const EDIT_PERMISSIONS = 'EDIT_PERMISSIONS'

// USER TRAFFIC LOG
export const GET_USER_LOG_LIST = 'GET_USER_LOG_LIST'

// USER CC
export const GET_CC_LIST = 'GET_CC_LIST'

// DEPARTEMENT
export const GET_DEPT_LIST = 'GET_DEPT_LIST'
export const EDIT_DEPT = 'EDIT_DEPT'
export const ADD_DEPT = 'ADD_DEPT'

// COMPANY
export const GET_COMPANY_LIST = 'GET_COMPANY_LIST'
export const EDIT_COMPANY = 'EDIT_COMPANY'
export const ADD_COMPANY = 'ADD_COMPANY'
export const GET_LOCATION_LIST = 'GET_LOCATION_LIST'
export const GET_WORK_LOCATION_LIST = 'GET_WORK_LOCATION_LIST'

// CONTRACTORS
export const GET_CONTRACTOR_LIST = 'GET_CONTRACTOR_LIST'
export const ADD_CONTRACTOR = 'ADD_CONTRACTOR'
export const EDIT_CONTRACTOR = 'EDIT_CONTRACTOR'

// CONTRACTOR CATEGORIES
export const GET_CONTRACTOR_CATEGORIES_LIST = 'GET_CONTRACTOR_CATEGORIES_LIST'

// TASK MANAGEMENTS
export const GET_SUPPORT_REQUEST = 'GET_SUPPORT_REQUEST'
export const GET_CONFORMITY_REPORT = 'GET_CONFORMITY_REPORT'
export const SET_SUPPORT_REQUEST = 'SET_SUPPORT_REQUEST'
export const SET_CONFORMITY_REPORT = 'SET_CONFORMITY_REPORT'
export const GET_CONFORMITY_CATEGORIES_LIST = 'GET_CONFORMITY_CATEGORIES_LIST'

// COLLABORATION
export const GET_COLLAB_SUPPORT_REQUEST = 'GET_COLLAB_SUPPORT_REQUEST'
export const GET_COLLAB_CONFORMITY_REPORT = 'GET_COLLAB_CONFORMITY_REPORT'

// NOTIFICATIONS
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS'

// LOOKUPS
export const SUPPORT_REQUEST_LOOKUP = 'SUPPORT_REQUEST_LOOKUP'
export const CONFORMITY_TYPE_LOOKUP = 'CONFORMITY_TYPE_LOOKUP'
export const CONFORMITY_DEPTS_LOOKUP = 'CONFORMITY_DEPTS_LOOKUP'
export const GET_CONTRACTOR_PIT_LOOKUPS = 'GET_CONTRACTOR_PIT_LOOKUPS'
export const SET_CONTRACTOR_LOOKUPS = 'SET_CONTRACTOR_LOOKUPS'
export const SET_PIT_LOOKUPS = 'SET_PIT_LOOKUPS'
export const SET_PIT_PLAN = 'SET_PIT_PLAN'
export const GET_LOOKUPS_SUCCEED = 'GET_LOOKUPS_SUCCEED'
export const GET_TUNNEL = 'GET_TUNNEL'
export const GET_ROM_LOOKUPS = 'GET_ROMS_LOOKUPS'

// VIEW TRIGGERS
export const SHOW_TAB = 'SHOW_TAB'
export const SHOW_LOADER = 'SHOW_LOADER'
export const SHOW_MOBILE = 'SHOW_MOBILE'

// SETTINGS TABLE
export const GET_LOCAL_SETTINGS_TABLE = 'GET_LOCAL_SETTINGS_TABLE'
export const SET_LOCAL_SETTINGS_TABLE = 'SET_LOCAL_SETTINGS_TABLE'

// GLOBALS
export const SET_GLOBAL_SITE = 'SET_GLOBAL_SITE'
export const SET_GLOBAL_COMPANY = 'SET_GLOBAL_COMPANY'

//DAILY REPORT
export const GET_DAILY_REPORT = 'GET_DAILY_REPORT'

//DAILY LOADING POINT
export const GET_DAILY_LOADING_POINT_LIST = 'GET_DAILY_LOADING_POINT_LIST'

//DATA VALIDATION
export const GET_HISTORY_DATA_VALIDATION = 'GET_HISTORY_DATA_VALIDATION'

// BLASTING REPORT
export const GET_BLASTING_REPORT_DETAIL = 'GET_BLASTING_REPORT_DETAIL'
export const GET_BLASTING_REPORT_LIST = 'GET_BLASTING_REPORT_LIST'

// STOCK OPNAME
export const GET_ROM_LOCATION_LIST = 'GET_ROM_LOCATION_LIST'
export const GET_ROM_LOCATION_DETAIL = 'GET_ROM_LOCATION_DETAIL'
export const GET_AREA_LIST = 'GET_AREA_LIST'
export const GET_DIR_LOCATION_LIST = "GET_DIR_LOCATION_LIST"
export const GET_PRODUCTS_LIST = 'GET_PRODUCTS_LIST'
